<ng-container *ngIf="formGroupNameValue" [formGroupName]="formGroupNameValue">
    <mat-form-field appearance="outline">
      <input autocomplete="nope" type="text" [id]="inputId" #countryInput terraForceAutoCompleteSelection [placeholder]="placeholderText "
        matInput [formControlName]="controlName" [matAutocomplete]="autoComplete" (focus)="$event.target.select(); updateOptionsPosition()"
        (focusout)="updateOptionsPosition()" (cdkAutofill)="setAutofillState($event.isAutofilled)">
      <mat-icon *ngIf="!form.get(controlName).value" [ngClass]="{'notranslate': true, 'drop-down-arrow': true, 'error-color': isError(), 'default-color': !isError()}" matSuffix>arrow_drop_down</mat-icon>
      <mat-icon (click)="clearText()" *ngIf="!!form.get(controlName).value" class="drop-down-clear notranslate default-color" matSuffix>clear</mat-icon>
      <mat-autocomplete #autoComplete="matAutocomplete" [displayWith]="displayFn" autoActiveFirstOption>
        <mat-option *ngFor="let countryOption of filteredCountries | async; trackBy: conutryTrackByFn"
          [value]="countryOption.id">
          <span class="notranslate">{{countryOption.name}}</span>
        </mat-option>
      </mat-autocomplete>
      <mat-error *ngIf="form.get(controlName).hasError('required')">
        Required
      </mat-error>
    </mat-form-field>
  </ng-container>
  <ng-container *ngIf="!formGroupNameValue">
    <mat-form-field appearance="outline">
      <input autocomplete="nope" type="text" [id]="inputId" #countryInput terraForceAutoCompleteSelection [placeholder]="placeholderText"
        matInput [formControlName]="controlName" [matAutocomplete]="autoComplete" (focus)="$event.target.select(); updateOptionsPosition()"
        (focusout)="updateOptionsPosition()" (cdkAutofill)="setAutofillState($event.isAutofilled)">
      <mat-icon *ngIf="!form.get(controlName).value" [ngClass]="{'notranslate': true, 'drop-down-arrow': true, 'error-color': isError(), 'default-color': !isError()}" matSuffix>arrow_drop_down</mat-icon>
      <mat-icon (click)="clearText()" *ngIf="!!form.get(controlName).value" class="drop-down-clear notranslate default-color" matSuffix>clear</mat-icon>
      <mat-autocomplete #autoComplete="matAutocomplete" [displayWith]="displayFn" autoActiveFirstOption>
        <mat-option *ngFor="let countryOption of filteredCountries | async; trackBy: conutryTrackByFn"
          [value]="countryOption.id">
          <span class="notranslate">{{countryOption.name}}</span>
        </mat-option>
      </mat-autocomplete>
      <mat-error *ngIf="form.get(controlName).hasError('required')">
        Required
      </mat-error>
    </mat-form-field>
  </ng-container>
